import Vue from 'vue'
import {BootstrapVue} from 'bootstrap-vue'
import {extend, localize, ValidationObserver, ValidationProvider} from 'vee-validate'
import * as veeRules from 'vee-validate/dist/rules'
import it from 'vee-validate/dist/locale/it.json'
import axios from 'axios'

import FloatInput from "@/components/inputs/FloatInput"
import FloatSelect from "@/components/inputs/FloatSelect"
import FloatDate from "@/components/inputs/FloatDate"
import RadioYesNo from "@/components/inputs/RadioYesNo"
import BaseFieldset from "@/components/BaseFieldset"
import CvtFleetAdjustment from "./CvtFleetAdjustment"

const fields = document.querySelectorAll('.cvt-fleet-adjustment-widget')

if (fields.length) {
    Vue.use(BootstrapVue)

    //register the vee-validate rules locally; the SPA plugin can't be imported (its cvt_targa rule
    //pulls @/services/api → @/main → router, dragging the whole SPA onto the admin page)
    Object.keys(veeRules).forEach(rule => extend(rule, veeRules[rule]))
    localize('it', it)
    extend('cvt_targa', {
        validate: async (value) => {
            if (!value) return true
            try {
                const {data} = await axios.post('/api/app/acclr/cvt/targa-validation', {targa: value}, {
                    headers: {'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json'},
                })
                const result = data.data || data
                return result.valid ? true : (result.message || 'Targa non valida')
            } catch (error) {
                const body = error.response && error.response.data ? error.response.data : {}
                const messages = Object.values(body.errors || {}).flat()
                return messages.length ? messages.join(' ') : (body.message || 'Targa non valida')
            }
        },
    })
    Vue.component('ValidationObserver', ValidationObserver)
    Vue.component('ValidationProvider', ValidationProvider)

    //the reused quotation inputs read these off the prototype (the SPA plugins provide them there)
    if (!Vue.prototype.$config) {
        Vue.prototype.$config = (path, defaultValue) => defaultValue
    }
    if (!Vue.prototype.$validation) {
        Vue.prototype.$validation = {
            getValidationState({dirty, validated, valid = null}) {
                return dirty || validated ? (valid ? null : false) : null
            },
        }
    }

    Vue.component('FloatInput', FloatInput)
    Vue.component('FloatSelect', FloatSelect)
    Vue.component('FloatDate', FloatDate)
    Vue.component('RadioYesNo', RadioYesNo)
    Vue.component('BaseFieldset', BaseFieldset);

    [...fields].forEach(el => {
        new Vue({
            name: 'cvt-fleet-adjustment-widget',
            el,
            components: {CvtFleetAdjustment},
            methods: {
                setValue(value) {
                    this.$refs.input.value = JSON.stringify(value)
                },
            },
        })
    })
}
